import React, { useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import styles
import './style.css';

const Editor = (props) => {
    const  { _stateValue, _stateName, handleChange, customClass, key } = props;
    const quillRef = useRef(null);
    const firstRender = useRef(true);

  const onChange = (content, delta, source, editor) => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }

    if (editor) {
      const contentDelta = editor.getContents();
      const contentHtml = editor.getHTML();

      // Only update if the Delta is not empty
      if (!isEmptyDelta(contentDelta)) {
        handleChange(_stateName, contentDelta, '', contentHtml);
      }
    }
  };

  function isEmptyDelta(delta) {
    if (!delta || !delta.ops) return true;
    return delta.ops.length === 1 && delta.ops[0].insert === '\n';
  }


  return (
      <ReactQuill
        key={key}
        ref={quillRef}
        value={_stateValue}
        theme="snow"
        onChange={onChange}
        modules={Editor.modules}
        formats={Editor.formats}
        bounds={"#root"}
        placeholder={props.placeholder}
        {...props}
      />
  );
};

Editor.modules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ["bold"],
    ["italic"],
    ["blockquote"],
    ["code-block"],
    [{ color: [] }, { background: [] }],
    [
      { list: "ordered" },
      { list: "bullet" },
    ],
    [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
    ["link"],
  ],
  clipboard: {
    matchVisual: false,
  },
};

Editor.formats = [
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
  "script",
  "header",
  "blockquote",
  "code-block",
  "list",
  "bullet",
  "direction",
  "align",
  "link",
];

export default Editor;